// extracted by mini-css-extract-plugin
export default {"title":"HudMobile_title__qYNsM","menuBtn":"HudMobile_menuBtn__NVzD6","navMenu":"HudMobile_navMenu__+Psn7","navItem":"HudMobile_navItem__2Yqfy","line":"HudMobile_line__i9kKU"};